import React, { useEffect } from "react";
import { Box, CssBaseline, Grid } from "@mui/material";

import { mainLayoutStyles } from "../../../../../constants";
import Header from "../../../../../common/Header";
import GeneralAdminSidebar from "../../../../../common/GeneralAdminSidebar";
import { NarratorsAnalytics, CreatorsAnalytics } from "../../components/components";
import { useDashboardContext } from "../../../../../providers/GeneralAdmin/DashboardProvider";
import { useAuth } from "../../../../../hooks";

const GADashboardContainer = () => {
  const {
    handleGetNarratorsAnalytics,
    narratorAnalytics,
    handleGetCreatorsAnalytics,
    creatorAnalytics,
    loading,
  } = useDashboardContext();
  const { currentUser } = useAuth();

  useEffect(() => {
    if (currentUser) {
      handleGetNarratorsAnalytics();
      handleGetCreatorsAnalytics();
    }
  }, [currentUser]);

  return (
    <Box sx={{ display: "flex", background: "#F5F5F5" }}>
      <CssBaseline />
      <Header mainTitle={"Admin Dashboard"} />
      <GeneralAdminSidebar />
      <Grid
        container
        style={{
          ...mainLayoutStyles,
          height: undefined,
          backgroundColor: "#F5F5F5",
        }}
      >
        <Grid container direction={"column"} style={{ background: "#F5F5F5" }}>
          {/* Analytics Section - Two Charts Side by Side */}
          <Grid container style={{ padding: 30 }} spacing={3}>
            {/* Narrator Analytics */}
            <Grid item xs={12} md={6}>
              <Grid 
                container 
                direction={"column"} 
                style={{
                  background: "#fff",
                  width: "100%",
                  minHeight: 600,
                  borderRadius: 5,
                  padding: 20,
                }}
              >
                <NarratorsAnalytics
                  narratorAnalytics={narratorAnalytics}
                  loading={loading}
                />
              </Grid>
            </Grid>
            
            {/* Creator Analytics */}
            <Grid item xs={12} md={6}>
              <Grid 
                container 
                direction={"column"} 
                style={{
                  background: "#fff",
                  width: "100%",
                  minHeight: 600,
                  borderRadius: 5,
                  padding: 20,
                }}
              >
                <CreatorsAnalytics
                  creatorAnalytics={creatorAnalytics}
                  loading={loading}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default GADashboardContainer;
